export class Sanitizer {
  sanitize(value) {
    return value.replace(this.LINEBREAKS(), ' ').replace(this.NOT_ALPHA_NUMERIC_WITH_SPECIAL_CHARS(), '').trim();
  }

  LINEBREAKS() {
    return /(\r\n|\n|\r)+/g;
  }

  NOT_ALPHA_NUMERIC_WITH_SPECIAL_CHARS() {
    return /[^0-9A-Za-zäöüÄÖÜßÀàÁáÂâÇçÈèÉéÊêÎîÔôÙùÛû§€$%&().=_,\-!?'\s]+/g;
  }
}
